module.exports = __webpack_public_path__ + "media/jingle_goal.ea96e2fe.mp3";